import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";
import classNames from "classnames";
import PropTypes from "prop-types";
import { sendTagOnBackButton } from "app/utils/analytics";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import { ChevronLeftIcon } from "app/components/icons/navigation/ChevronLeftIcon";
import styles from "./BackButton.module.scss";

export const BackButton = ({ className, onClick, to, children, ...props }) => {
	const { pathname } = useLocation();
	const navigate = useNavigate();

	const handleClick = useCallback(() => {
		sendTagOnBackButton(pathname);
		onClick();

		if (!to) {
			navigate(-1);
		}
	}, [pathname, onClick, navigate, to]);

	const buttonClassName = classNames(styles["back-button"], className);

	return (
		<Button
			variant={BUTTON_VARIANTS.BORDERLESS}
			size={BUTTON_SIZES.LARGE}
			className={buttonClassName}
			onClick={handleClick}
			to={to}
			replace={Boolean(to)}
			data-testid="back-button"
			icon={<ChevronLeftIcon />}
			{...props}
		>
			{children}
		</Button>
	);
};

BackButton.propTypes = {
	className: PropTypes.string,
	onClick: PropTypes.func,
	to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	children: PropTypes.node,
};
